import React from 'react';
import { CircleIcon } from '../elements/circle-icon';
export var CrossCircle = function CrossCircle(_a) {
  var className = _a.className;
  return React.createElement(CircleIcon, {
    className: className,
    viewBox: "0 0 16 16"
  }, React.createElement("g", null, React.createElement("path", {
    d: "M8 1.3913C11.6452 1.3913 14.6087 4.35478 14.6087 8C14.6087 11.6452 11.6452 14.6087 8 14.6087C4.35478 14.6087 1.3913 11.6452 1.3913 8C1.3913 4.35478 4.35478 1.3913 8 1.3913ZM8 0C3.58261 0 0 3.58261 0 8C0 12.4174 3.58261 16 8 16C12.4174 16 16 12.4174 16 8C16 3.58261 12.4174 0 8 0Z"
  }), React.createElement("path", {
    d: "M11.4436 10.4592L8.98447 8.00012L11.4436 5.54099L10.4592 4.55664L8.00012 7.01577L5.54099 4.55664L4.55664 5.54099L7.01577 8.00012L4.55664 10.4592L5.54099 11.4436L8.00012 8.98447L10.4592 11.4436L11.4436 10.4592Z"
  })));
};